<template>
  <vx-card slot="no-body" :title="$t('GradeControl.Reports.Title')" class="text-center greet-user" v-show="$auth.checkRoles(gcRoles.readers)">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">
        <h5 class="text-left mb-3">{{ this.$t('GradeControl.Reports.Annual')}}</h5>
        <menu-control :items="annualItems" />
        <h5 class="text-left mb-3">{{ this.$t('GradeControl.Reports.Monthly')}}</h5>
        <menu-control :items="monthlyItems" />
        <div  v-show="$auth.checkRoles(gcRoles.readers) && ($auth.checkRoles(['GoldexUsers']) || $auth.checkRoles(['Admin']))">
          <h5 class="text-left mb-3">{{ this.$t('GradeControl.Reports.Goldex')}}</h5>
          <menu-control :items="goldexItems" />
        </div>
        <div  v-show="$auth.checkRoles(gcRoles.readers) && ($auth.checkRoles(['OdysseyUsers']) || $auth.checkRoles(['Admin']))">
          <h5 class="text-left mb-3">{{ this.$t('GradeControl.Reports.Odyssey')}}</h5>
          <menu-control :items="odysseyItems" />
        </div>
        <div  v-show="$auth.checkRoles(gcRoles.readers) && ($auth.checkRoles(['DetourUsers']) || $auth.checkRoles(['Admin']))">
          <h5 class="text-left mb-3">{{ this.$t('GradeControl.Reports.Detour')}}</h5>
          <menu-control :items="detourItems" />
        </div>
      </div>
      <div class="vx-col w-full md:w-1/2">
        <h5 class="text-left mb-3">{{ this.$t('GradeControl.Reports.Periodic')}}</h5>
        <menu-control :items="periodicItems" />
        <h5 class="text-left mb-3">{{ this.$t('Statistics')}}</h5>
        <menu-control :items="statisticItems" />
      </div>
    </div>
  </vx-card>
</template>
<script>
import gcRoles from './../roles.js'
import menuControl from '@/app/shared/components/lists/menu.vue'

export default {
  components: {
    menuControl
  },
  data() {
    return {
      gcRoles,
      annualItems : [
        {
          roles : gcRoles.readers,
          icon : "BarChart2Icon",
          to : "/geo/gradecontrol/reports/locationsummary",
          i18nTitle : "GradeControl.Reports.LocationSummary"
        },
        {
          roles : gcRoles.readers,
          icon : "BarChartIcon",
          to : "/geo/gradecontrol/reports/productionsummary",
          i18nTitle : "GradeControl.Reports.ProductionSummary"
        }
      ],
      monthlyItems : [
        {
          roles : gcRoles.readers,
          icon : "CalendarIcon",
          to : "/geo/gradecontrol/monthlySummary",
          i18nTitle : "GradeControl.MonthlySummary.Title"
        },
        {
          roles : gcRoles.readers,
          icon : "BarChart2Icon",
          to : "/geo/gradecontrol/productionsummary",
          i18nTitle : "GradeControl.ProductionSummary.LongTitle"
        },
        {
          roles : gcRoles.readers,
          icon : "BarChartIcon",
          to : "/geo/gradecontrol/reports/postingsummary",
          i18nTitle : "GradeControl.Reports.PostingSummary"
        }
      ],
      periodicItems : [
        {
          roles : gcRoles.readers,
          icon : "TrendingUpIcon",
          to : "/geo/gradecontrol/reports/periodicsummary",
          i18nTitle : "GradeControl.Reports.Summary"
        },
        {
          roles : gcRoles.readers,
          icon : "CalendarIcon",
          to : "/geo/gradecontrol/reports/periodicsummarymaterialtypes",
          i18nTitle : "GradeControl.Reports.SummaryOtherMaterial"
        },
        {
          roles : gcRoles.readers,
          icon : "TruckIcon",
          to : "/geo/gradecontrol/reports/dailymonitoring",
          i18nTitle : "GradeControl.Reports.DailyMonitoring"
        },
        {
          roles : gcRoles.readers,
          icon : "TruckIcon",
          to : "/geo/gradecontrol/reports/stockpile",
          i18nTitle : "GradeControl.Reports.Stockpile"
        },
        {
          roles : gcRoles.readers,
          icon : "ListIcon",
          to : "/geo/gradecontrol/reports/dailyLocationStats",
          i18nTitle : "GradeControl.Reports.DailyLocationStats"
        },
        {
          roles : gcRoles.readers,
          icon : "ListIcon",
          to : "/geo/gradecontrol/reports/locationSummaryStats",
          i18nTitle : "GradeControl.Reports.LocationSummaryStats"
        }
      ],
      statisticItems : [
        {
          roles : gcRoles.readers,
          faIcon : "vial",
          to : "/geo/gradecontrol/reports/samplestats",
          i18nTitle : "GradeControl.Reports.SampleStats"
        },
        {
          roles : gcRoles.readers,
          faIcon : "vial",
          to : "/geo/gradecontrol/reports/labstats",
          i18nTitle : "GradeControl.Reports.LabStats"
        },
        {
          roles : gcRoles.readers,
          faIcon : "vial",
          to : "/geo/gradecontrol/reports/sampleanomalies",
          i18nTitle : "GradeControl.Reports.SampleAnomalies"
        },
        {
          roles : gcRoles.readers,
          faIcon : "vial",
          to : "/geo/gradecontrol/reports/samplesummary",
          i18nTitle : "GradeControl.Reports.SampleSummary"
        },
        {
          roles : gcRoles.readers,
          faIcon : "vial",
          to : "/geo/gradecontrol/reports/sample",
          i18nTitle : "GradeControl.Reports.SampleTracking"
        }
      ],
      goldexItems : [
        {
          roles : gcRoles.readers,
          icon : "ListIcon",
          to : "/geo/gradecontrol/reports/deswikexport",
          i18nTitle : "GradeControl.Reports.DeswikExport"
        }
      ],
      odysseyItems : [
        {
          roles : gcRoles.readers,
          icon : "ListIcon",
          to : "/geo/gradecontrol/reports/odysseydeswikexport",
          i18nTitle : "GradeControl.Reports.DeswikExport"
        }
      ],
      detourItems : [
        {
          roles : gcRoles.readers,
          icon : "ListIcon",
          to : "/geo/gradecontrol/reports/detourdeswikexport",
          i18nTitle : "GradeControl.Reports.DeswikExport"
        }
      ]
    }
  }
};
</script>
